import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue";
import { provide, computed, toRef } from "vue";
import AppFormFieldSkeleton from "./AppFormFieldSkeleton.vue";
import { useFormFieldDisplayCondition } from "./utils";
import { combineTranslationField } from "./utils";
import gql from "fraql";
const __default__ = {
    name: "AppFormFieldContainer",
    fragments: {
        formFieldFields: gql `
      fragment _ on FormField {
        parentName
        name
        ${AppFormFieldSkeleton.fragments.formField}
      }
    `
    }
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        modelValue: {},
        formFields: {},
        disabled: { type: Boolean },
        validationProps: { default: () => ({
                fieldDisabled: v => false,
                fieldErrors: v => [],
                validationObject: {}
            }) }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const modelValueForward = computed({
            get() {
                return props.modelValue;
            },
            set(v) {
                emit("update:modelValue", v);
            }
        });
        const formFields = toRef(props, "formFields");
        const { isFieldVisible } = useFormFieldDisplayCondition(formFields, modelValueForward);
        const processedFormFields = computed(() => {
            let fields = combineTranslationField(formFields.value ?? []);
            return {
                fields: fields.filter(x => !x.parentName || x.parentName == "customFieldValues"),
                subFields: fields.filter(x => !!x.parentName && x.parentName != "customFieldValues")
            };
        });
        function isClearable(formField) {
            return true;
        }
        function blurEvent(formField) {
            if (!formField)
                return null;
            return props.validationProps.validationObject[formField.name]
                ? props.validationProps.validationObject[formField.name].$touch()
                : null;
        }
        provide("FormFieldContainerValidationHelper", {
            fieldErrors: (v) => props.validationProps.validationObject[v]
                ? props.validationProps.fieldErrors(v)
                : [],
            fieldDisabled: (v) => props.validationProps.validationObject[v]
                ? props.validationProps.fieldDisabled(v)
                : false,
            clearable: isClearable
        });
        return (_ctx, _cache) => {
            const _component_v_expand_transition = _resolveComponent("v-expand-transition");
            return (_openBlock(), _createElementBlock("div", null, [
                _renderSlot(_ctx.$slots, "formFieldContent", _normalizeProps(_guardReactiveProps({ processedFormFields: processedFormFields.value })), () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedFormFields.value.fields, (formField) => {
                        return (_openBlock(), _createBlock(_component_v_expand_transition, {
                            key: formField.name + formField.inputType + formField.entity
                        }, {
                            default: _withCtx(() => [
                                (_unref(isFieldVisible)(formField))
                                    ? (_openBlock(), _createBlock(AppFormFieldSkeleton, _mergeProps({
                                        key: 0,
                                        modelValue: modelValueForward.value[formField.name],
                                        "onUpdate:modelValue": ($event) => ((modelValueForward.value[formField.name]) = $event)
                                    }, { ref_for: true }, _ctx.$attrs, {
                                        "form-field": formField,
                                        "data-test": formField.name,
                                        "sub-props": {
                                            subFormFields: processedFormFields.value.subFields
                                        },
                                        translations: formField.translationFieldName
                                            ? modelValueForward.value[formField.translationFieldName]
                                            : undefined,
                                        "error-messages": _ctx.validationProps.fieldErrors(formField.name),
                                        disabled: _ctx.disabled || _ctx.validationProps.fieldDisabled(formField.name),
                                        clearable: isClearable(formField),
                                        "onUpdate:translations": $event => (modelValueForward.value[formField.translationFieldName] = $event),
                                        onBlur: blurEvent
                                    }), {
                                        [formField.name]: _withCtx(({ bindProps, emits, component }) => [
                                            _renderSlot(_ctx.$slots, formField.name, {
                                                formField: formField,
                                                bindProps: bindProps,
                                                component: component,
                                                emits: {
                                                    ...emits,
                                                    onBlur: blurEvent,
                                                    'update:translations': $event => (modelValueForward.value[formField.translationFieldName] = $event)
                                                },
                                                rootProps: {
                                                    formField,
                                                    dataTest: formField.name,
                                                    subProps: {
                                                        subFormFields: processedFormFields.value.subFields
                                                    },
                                                    clearable: isClearable(formField),
                                                    errorMessages: _ctx.validationProps.fieldErrors(formField.name),
                                                    disabled: _ctx.disabled || _ctx.validationProps.fieldDisabled(formField.name),
                                                    translations: formField.translationFieldName
                                                        ? modelValueForward.value[formField.translationFieldName]
                                                        : undefined
                                                }
                                            })
                                        ]),
                                        _: 2
                                    }, 1040, ["modelValue", "onUpdate:modelValue", "form-field", "data-test", "sub-props", "translations", "error-messages", "disabled", "clearable", "onUpdate:translations"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ])
            ]));
        };
    }
});
